import { jsx as _jsx } from "react/jsx-runtime";
import { DirectionalHint, FontWeights, IconButton, } from '@fluentui/react';
import { useAppShell } from '../AppShellContext';
import { useHistory, useLocation } from 'react-router-dom';
import { useThemeData } from '@msrceng/theme';
import { APPBAR_HEIGHT } from '../../Appbar';
import { useAppBarColor } from '../../Appbar/useAppBarBackgroundColor';
/**
 * Renders an array of links in a Fluent UI `ContextualMenu` component
 * (controlled by a `DefaultButton` component)
 */
export const AppSidebarMenu = ({ isViewportWidthLarge }) => {
    const { appLinksWithHome } = useAppShell();
    const history = useHistory();
    const { pathname } = useLocation();
    const { theme: { palette, semanticColors }, } = useThemeData();
    const { color, background } = useAppBarColor();
    if (isViewportWidthLarge) {
        return null;
    }
    const items = appLinksWithHome.map(({ iconName, name, url }) => ({
        canCheck: true,
        checked: url === pathname,
        iconProps: { iconName },
        key: name,
        onClick: () => history.push(url),
        text: name,
    }));
    return (_jsx(IconButton, { primary: true, title: 'Navigation', iconProps: { iconName: 'CollapseMenu' }, menuProps: {
            title: 'Navigation menu',
            directionalHint: DirectionalHint.bottomLeftEdge,
            isBeakVisible: false,
            items,
            styles: {
                root: {
                    borderRadius: '0',
                    color: semanticColors.actionLink,
                    selectors: {
                        '.ms-ContextualMenu-checkmarkIcon': {
                            display: 'none',
                        },
                        '.is-checked': {
                            background: palette.neutralQuaternaryAlt,
                        },
                        '.is-checked .ms-ContextualMenu-itemText': {
                            fontWeight: FontWeights.semibold,
                        },
                        '.ms-ContextualMenu-icon': {
                            color: 'inherit',
                            margin: '0 3px 0 14px',
                        },
                    },
                },
            },
            useTargetWidth: false,
        }, styles: {
            root: {
                background,
                color,
                border: '0',
                borderRadius: '0',
                height: APPBAR_HEIGHT,
                paddingBottom: '1rem',
                paddingTop: '1rem',
                textAlign: 'left',
                width: '100%',
            },
            menuIcon: {
                display: 'none',
            },
            rootHovered: {
                background: palette.themeDark,
                color: palette.yellowLight,
            },
            rootFocused: {
                background,
                color,
            },
            rootExpanded: {
                background,
                color,
            },
        } }));
};
